import type { IconOwnProps } from '@ps/isp-web-component-library';
import { Break } from '@ps/isp-web-component-library/icons/Break';
import { Finished } from '@ps/isp-web-component-library/icons/Finished';
import { InPlay } from '@ps/isp-web-component-library/icons/InPlay';
import type { TennisFragment, TennisStatusReason } from '@ps/web-shared-generated-graphql/sports';
import React from 'react';

import EventStatusMessage from '../../EventStatusMessage/EventStatusMessage';

import PreviousSetsScore from './PreviousSetScore';

type TennisStatusReasonToIconNameMap = {
  [P in TennisStatusReason]?: IconOwnProps['icon'];
};

const tennisStatusReasonToIconNameMap: TennisStatusReasonToIconNameMap = {
  RAIN_DELAY: Break,
  HEAT_DELAY: Break,
  TOILET_BREAK: Break,
  FINISHED: Finished
};

export interface Props {
  tennisMatch: TennisFragment;
}

const TennisScoreboardInPlayStatus: React.FC<Props> = ({ tennisMatch }) => {
  const { previousSets, status, currentSet } = tennisMatch;
  const reason = status?.reason;

  const isInterruptedStatus = status?.status === 'INTERRUPTED';
  const isTieBreak = currentSet?.currentGame?.type === 'TIEBREAK';

  const eventScoreComponent = previousSets?.length ? (
    <PreviousSetsScore previousSets={previousSets} />
  ) : undefined;

  if (isTieBreak && isInterruptedStatus && reason) {
    return (
      <EventStatusMessage
        eventScoreComponent={eventScoreComponent}
        messageId={reason}
        icon={tennisStatusReasonToIconNameMap[reason]}
        size="XSmall"
      />
    );
  }

  if (isTieBreak) {
    return (
      <EventStatusMessage
        eventScoreComponent={eventScoreComponent}
        messageId="TIE_BREAK"
        icon={InPlay}
        size="XSmall"
      />
    );
  }

  if (reason) {
    return (
      <EventStatusMessage
        eventScoreComponent={eventScoreComponent}
        messageId={reason}
        icon={tennisStatusReasonToIconNameMap[reason] || InPlay}
        size="XSmall"
      />
    );
  }

  return (
    <EventStatusMessage
      eventScoreComponent={eventScoreComponent}
      messageId="IN_PLAY"
      icon={InPlay}
      size="XSmall"
    />
  );
};

export default TennisScoreboardInPlayStatus;
